import { FC } from "react";
import { BaseGridSearchFilterProperties } from "./BaseGridSearchFilter";
import { useRecoilCallback, useRecoilValue } from "recoil";
import {
  BaseGridKeyNameMapAtom,
  BaseGridKeyNameMapProperty,
} from "../BaseGridAtoms";
import { useGridInstance } from "../Hooks/useGridInstance";
import { BaseGridFilterParameters } from "../Hooks/useBaseGridFilters";
import BaseGridSearchFilter from "./BaseGridSearchFilter";

type BaseGridSearchPersistValueFilterProperties =
  BaseGridSearchFilterProperties & {
    tableName: string;
  };
const BaseGridSearchPersistValueFilter: FC<
  BaseGridSearchPersistValueFilterProperties
> = ({
  options,
  id,
  columnNames,
  columnDisplayNames,
  searchColumnsConnector,
  permissions,
  isHidden,
  searchOnEnterOnly = true,
  resetOnManuallyReload,
  tableName = "",
}) => {
  const getMappedInstanceState = useRecoilCallback(
    ({ snapshot }) =>
      (tableName) => {
        const instance =
          (snapshot.getLoadable(BaseGridKeyNameMapAtom)
            .contents as BaseGridKeyNameMapProperty[]) ?? null;

        const keyNameMap = instance?.find((z) => z.name === tableName) ?? null;

        return {
          ...keyNameMap,
        };
      }
  );
  const { instanceInternalSelector } = useGridInstance(
    getMappedInstanceState(tableName).uiid ?? "",
    "BaseGridSearchPersistValueFilter"
  );

  const filterParameters: BaseGridFilterParameters[] | null | undefined =
    useRecoilValue(instanceInternalSelector("filterParameters"));

  return (
    <>
      <BaseGridSearchFilter
        options={options}
        id={id}
        columnNames={columnNames}
        columnDisplayNames={columnDisplayNames}
        persistedValue={
          filterParameters?.[0]?.filterValue !== "all"
            ? filterParameters?.[0]?.filterValue
            : ""
        }
        searchColumnsConnector={searchColumnsConnector}
        permissions={permissions}
        isHidden={isHidden}
        searchOnEnterOnly={searchOnEnterOnly ?? true}
        resetOnManuallyReload={resetOnManuallyReload}
      />
    </>
  );
};

export default BaseGridSearchPersistValueFilter;
